var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"isloading-animate",class:{primary:_vm.primary},style:({width:_vm.size+'px',height:_vm.size+'px'})},[_c('div'),_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }